export const INBOUND_ADDON_FEATURE_KEY = 'visitors_qatar_inbound'
export const OCR_FEATURE_KEY = 'visitors_qatar_ocr'
export const OOREDOO_FEATURE_KEY = 'visitors_ooredoo_offer'
export const MARITAL_STATUS_FEATURE_KEY = 'visitors_marital_status'
export const FEATURES = [INBOUND_ADDON_FEATURE_KEY, OCR_FEATURE_KEY, OOREDOO_FEATURE_KEY, MARITAL_STATUS_FEATURE_KEY]
